var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMarkerIcon = function SvgMarkerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.967 14.167C30.7-.267 9.317-.283 6.034 14.15c-1.917 8.467 3.35 15.65 7.95 20.083 3.366 3.234 8.666 3.234 12.016 0 4.617-4.433 9.883-11.6 7.967-20.066ZM25.2 17.183a5.2 5.2 0 1 1-10.4 0 5.2 5.2 0 0 1 10.4 0Z",
    fill: "#070E54"
  })));
};

export { SvgMarkerIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/marker-icon.34f8a98c.svg";